import React, { useEffect, useRef, useState } from 'react';
import SectionWithTitle from '../../components/SectionWithTitle';
import SectionWithTitleContent from '../../components/SectionWithTitleContent';
import IconWithTitle from '../../components/IconWithTitle';
import IconWithDescription from '../../components/IconWithDescription';
import LocationByCsv from './LocationByCsv';

import { importDirectoyFiles } from '../../controller/SimpleFileReader';
import './styles.css';

import { sections } from './data';
import TablesByLocation from '../../components/TablesByLocation';

console.log('\n\n\n\n');

const Summer = () => {
  const csvFilesKeys = Object.keys(
    importDirectoyFiles(require.context('./csvData', false, /\.(csv)$/))
  );
  const csvUrls = Object.values(
    importDirectoyFiles(require.context('./csvData', false, /\.(csv)$/))
  );
  const csvFiles = importDirectoyFiles(
    require.context('./csvData', false, /\.(csv)$/)
  );

  // let newSections = [];
  // const [csvArray, setCsvArray] = useState([]);
  const [newSections, setNewSections] = useState([]);

  // let url = ["https://www.freecodecamp.org", "https://www.test.de/, http://www.test2.com"];
  let csvArray = new Array();
  var fetches = [];
  for (let i = 0; i < csvUrls.length; i++) {
    // console.log(csvUrls[i]);
    fetches.push(
      fetch(csvUrls[i])
        .then(res => {
          return res.text();
        })
        .then(res => {
          // let reg = /\<meta name="description" content\=\"(.+?)\"/;
          // res = res.match(reg);
          // processCsv(csvUrls[i], res)
          // setCsvArray(array);
          csvArray.push(res);
          // console.log(res);
        })
        .catch(err => {
          return console.log(err);
        })
    );
  }
  setNewSections(
    Promise.all(fetches).then(function () {
      // setCsvArray(array);
      let arr = [];

      for (let i = 0; i < csvArray.length; i++) {
        // const element = csvArray[i];
        const processed = processCsv(csvFilesKeys[i], csvArray[i]);
        arr.push(processed);
      }
      // const filtered = filterCamps(sections, arr);
      return filterCamps(sections, arr);
      // console.log(sections);
      // newSections = filtered;
      // This works here, but I can't get 'newSections' out of the Promise.
      // console.log(newSections);
    })
  );

  // console.log(csvArray);

  const processCsv = (name, str, delim = ',') => {
    const headers = str.slice(0, str.indexOf('\r')).split(delim);
    const rows = str.slice(str.indexOf('\r') + 1).split('\r\n');

    const newFileObject = {
      file: name,
      name: name.replace('.csv', ''),
      headers,
      camps: rows.map(row => {
        row = row.replace(/\n/, '');
        const values = row.split(delim);
        const eachObject = headers.reduce((obj, header, index) => {
          obj[header] = values[index];
          return obj;
        }, {});
        return eachObject;
      }),
    };

    return newFileObject;

    // setCsvArray([...csvArray, newFileObject]);
  };

  const filterCamps = (sections, csvArr) => {
    const newSections = sections.map(section => {
      const newSection = {
        title: section.title,
        content: [],
      };
      const newContent = section.content.map(camp => {
        const newCampContent = {
          name: camp.name,
          ages: camp.ages,
          path: camp.path,
          description: camp.description,
          alt: camp.alt,
          link: camp.link,
          tables: [],
        };

        const newCampTables =
          csvArr
            .map(csv => {
              const newTables = {
                file: csv.file,
                name: csv.name,
                headers: csv.headers,
                camps: [],
              };

              const filteredCamps = csv.camps.filter(
                table => table['Summer Camp Title'] === newCampContent.name
              );

              newTables.camps = filteredCamps;

              return newTables;
            })
            .filter(csv => csv.camps.length > 0) || [];
        newCampContent.tables = newCampTables;

        return newCampContent;
      });

      newSection.content = newContent;

      return newSection;
    });

    return newSections;
  };

  // useEffect(() => {
  //   csvFilesKeys.map(fileName =>
  //     fetch(csvFiles[fileName])
  //       .then(response => response.text())
  //       .then(data => processCsv(fileName, data))
  //   );
  // }, []);

  // useEffect(() => {
  //   setNewSections(filterCamps(sections, csvArray));
  //   console.log('newSections', JSON.stringify(newSections));
  // }, [csvArray]);

  return (
    <div className='summer-page-container'>
      {console.log(newSections)}
      {newSections.map((section, index) => {
        return (
          <div key={index}>
            <SectionWithTitle
              title={section.title}
              children={
                <div key={section.title}>
                  <SectionWithTitleContent
                    content={section.content.map(
                      (content, i) =>
                        content.tables.length > 0 && (
                          <div key={i}>
                            <IconWithDescription
                              path={content.path}
                              name={content.name}
                              description={content.description}
                              link={content.link}
                            />
                            {content.tables.map(table => (
                              <div key={table.name}>
                                <TablesByLocation table={table} />
                              </div>
                            ))}
                          </div>
                        )
                    )}
                  />
                </div>
              }
            />
          </div>
        );
      })}
    </div>
  );
};
export default Summer;
